// #3185 APPROVE.2 2c (Codex R2 finding 2, ruling 6537648337 item 2): fail
// closed plus a switch prompt. useMyTenant() describes the JWT-selected
// workspace, while the project routes resolve the caller's standing from the
// project's own workspace. When the two differ, the client approval controls
// (the override panel, Stakeholders management, Confirm) are hidden rather
// than drawn from the selected workspace's standing, and this prompt shows.

import { useOptionalTenantContext } from '../../contexts/TenantContext';

/** 'pending' until the project's workspace is known: controls stay hidden. */
export type ProjectWorkspace = 'pending' | 'selected' | 'other';

export function projectWorkspace(projectTenantId: string | null | undefined, selectedTenantId: string | null | undefined): ProjectWorkspace {
  if (!projectTenantId || !selectedTenantId) return 'pending';
  return projectTenantId === selectedTenantId ? 'selected' : 'other';
}

export const otherWorkspaceCopy = (name: string) =>
  `This project belongs to ${name}. Switch to that workspace to manage client approvals.`;

export default function OtherWorkspacePrompt({ projectTenantId }: { projectTenantId: string }) {
  const ctx = useOptionalTenantContext();
  const target = ctx?.availableTenants.find((t) => t.id === projectTenantId);
  return (
    <div
      role="note"
      data-testid="client-approvals-other-workspace"
      style={{
        display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', margin: '0 0 16px', padding: '10px 12px',
        fontSize: 13, color: 'var(--text)', background: 'var(--surface-alt)', border: '1px solid var(--border)',
        borderRadius: 'var(--radius-sm)',
      }}
    >
      <span>{otherWorkspaceCopy(target?.name ?? 'another workspace')}</span>
      {target && ctx && (
        <button
          type="button"
          onClick={() => { void ctx.switchTenant(target.id); }}
          style={{
            padding: '4px 12px', borderRadius: 6, border: '1px solid var(--primary)', background: 'transparent',
            color: 'var(--primary)', fontSize: 12, cursor: 'pointer',
          }}
        >
          Switch to {target.name}
        </button>
      )}
    </div>
  );
}
